import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

const getQuoteCargoTypesApi = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.PRIMARY}/GetAvailableInPricingCargoTypes`,
  });
};

export type QuoteCargoTypesListResponse = {
  codeId: string;
  codeDesc: string;
  value1: string;
  value2: string;
  value3: string;
  string1: string;
  string2: string;
  string3: string;
}[];

export const fetchQuoteCargoTypesList = async (): Promise<QuoteCargoTypesListResponse> => {
  const response: AxiosResponse<QuoteCargoTypesListResponse> = await getQuoteCargoTypesApi();
  return response.data;
};
